import { render, staticRenderFns } from "./ListaCotacaoIdentificador.vue?vue&type=template&id=4e1ac638&"
import script from "./ListaCotacaoIdentificador.vue?vue&type=script&lang=js&"
export * from "./ListaCotacaoIdentificador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VEditDialog})
